import { dynamicRender } from './dynamicRender';

export const parseJson = (data) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
};
